import { forwardRef } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
}

// eslint-disable-next-line react/display-name
const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>((props, ref) => {
  const {
    loading,
    children,
    ...rest
  } = props;
  return <Button {...rest} ref={ref} disabled={loading || rest.disabled} endIcon={loading ? <CircularProgress size={22} color='inherit' sx={{
    mx: 1
  }} /> : null}>
        {children}
      </Button>;
});
export default LoadingButton;